import {WHITE, lineGamer} from 'app/lines/line_helpers';
import LineInterface from 'app/interfaces/LineInterface';

export interface GroupedData {
  [key: string]: LineInterface[];
}

export const nestedLineGroupKey = (item: LineInterface): string => {
    if (item.type !== 'Handicap' && item.type !== 'NestedBet') {
        return item.type;
    }

    if (typeof item.nested_line_type_id === 'number') {
        return `type-${item.nested_line_type_id}`;
    }

    const gameInfo = lineGamer(item, 1);

    return gameInfo?.game_name || item.type;
};

export const groupByType = (nestedBets: LineInterface[], results: boolean): GroupedData => {
    const sortedNestedBets = [...nestedBets].sort((a, b) => a.priority - b.priority);

    return sortedNestedBets.reduce((acc, item) => {
        const key = nestedLineGroupKey(item);

        if (!acc[key]) {
            acc[key] = [];
        }

        if (!item.hide && (item.color === WHITE && results || item.color !== WHITE)) {
            acc[key].push(item);
        }

        return acc;
    }, {} as GroupedData);
};
